exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pointer-click[data-v-bc6211c0]{cursor:pointer}", ""]);

// exports
